import api from "./axios";

class ServiceCustomerProperty {
  async save(property) {
    const { data } = await api.post("/customer_properties", property)
    return data.id;
  }

  async update(property) {
    await api.put(`/customer_properties/${property.id}`, property);
  }

  async delete(id) {
    await api.delete(`/customer_properties/${id}`);
  }

  async findById(id) {
    const { data } = await api.get(`/customer_properties/${id}`);
    return data;
  }

  async fillComobobox(idCliente) {
    const { data } = await api.get(`/customer_properties/combobox/${idCliente}`);
    return data;
  }
}

export default new ServiceCustomerProperty()